<!--
 * @Author: maqian
 * @Date: 2023-12-25 16:39:59
 * @LastEditors: maqian maqian@aeonmed.com
 * @LastEditTime: 2025-08-22 15:24:27
 * @Description:
-->
<template>
  <div class="page-container">
      <!-- <div class="select-region">
          <div class="select-region-label" @click="showPicker = true">
            <span>{{ selectRegion }}</span>
            <img src="@/assets/arrow-down.png"/>
          </div>
          <ul class="select-region-picker" :class="{'open': showPicker}">
            <li
            v-for="region in regionOption"
            :key="region"
            :value="region"
            :class="{'active': selectRegion === region }"
            @click="handleSelect(region)"
            >
              {{ region }}
            </li>
          </ul>
      </div> -->
      <div class="top">
        <img src="@/assets/heyer.png" style="width: 263px;height: 72px;">
        <div class="click-tip">Please click the app to download</div>
        <div class="app-container">
            <div class="logo" @click="download(item)" v-for="item in appList" :key="item.appName">
              <img :src="item.logo" />
              <div >{{ item.appName }}</div>
            </div>
        </div>
        <div class="desc" style="font-size: 16px; margin-top: 20px;" v-for="item in appList" :key="item.appName">
          <div class="desc-name">{{ item.appName }} APP:</div>
          <div class="desc-text">
            {{ item.title }}<br />{{ item.subTilte }}
          </div>
        </div>
        <div style="font-size:12px; margin-top: 50px; padding-bottom: 24px;">E-mail：marketing@heyermed.com</div>
      </div>
      <div class="mask" v-show="showPicker" @click="showPicker = false"></div>
  </div>
</template>
<script>
import Logo from '@/assets/logo.png'
import yianLogo from '@/assets/yian.png'
const regionOption = ['Australia', 'Greece']

const appConfig = {
  'Australia': {
    appName: 'LuvMe',
    logo: Logo,
    title: 'CPAP Therapy Data at Your Fingertips',
    subTilte: '– Your Portable Sleep Health Monitoring & Improvement Hub',
    iosUrl: 'https://apps.apple.com/app/luvme/id6742822367',
    androidUrl: ''
  },
  'Greece': {
    appName: 'LuvLink',
    logo: yianLogo,
    title: 'Effortless WiFi Setup for Your Heyer AS/BF Series Devices',
    subTilte: 'Simplify Device Configuration in Seconds',
    iosUrl: 'https://apps.apple.com/app/luvlink/id6743191754',
    androidUrl: ' https://www.pgyer.com/bG0MgghA'
  }
}

export default {
  name: 'index',
  data () {
    return {
      selectRegion: 'Australia',
      regionOption: Object.freeze(regionOption),
      appList: [
        {
          appName: 'LuvMe',
          logo: Logo,
          title: 'CPAP Therapy Data at Your Fingertips',
          subTilte: '– Your Portable Sleep Health Monitoring & Improvement Hub',
          iosUrl: 'https://apps.apple.com/app/luvme/id6742822367',
          androidUrl: ''
        },
        {
          appName: 'LuvLink',
          logo: yianLogo,
          title: 'Effortless WiFi Setup for Your Heyer AS/BF Series Devices',
          subTilte: '- Simplify Device Configuration in Seconds',
          iosUrl: 'https://apps.apple.com/app/luvlink/id6743191754',
          androidUrl: ' https://www.pgyer.com/bG0MgghA'
        }
      ],
      showPicker: false
    }
  },
  watch: {
    selectRegion: {
      handler () {
        this.app = appConfig[this.selectRegion]
      },
      immediate: true
    }
  },
  methods: {
    download (item) {
      this.$router.push({
        name: item.appName
      })
    },
    handleSelect (item) {
      this.selectRegion = item
      this.showPicker = false
    }
  }
}
</script>
<style scoped>
.page-container{
  text-align: center;
}
.mask{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.2);
  z-index: 1
}
.select-region{
  position: fixed;
  top: 10px;
  right: 24px;
  z-index: 10;
}
.select-region-picker{
  position: absolute;
  top: 20px;
  width: 102px;
  height: 0;
  background: #FFFFFF;
  border-radius: 8px;
  color: #292B3F;
  padding: 0;
  overflow: hidden;
  transition: height .2s ease;
}
.select-region-picker.open{
  height: 96px;
}
.select-region-picker li{
    height: 48px;
    line-height: 48px;
    list-style: none;
    text-align: left;
    padding-left: 16px
}
.select-region-picker li.active{
  color: #36B4C6;
}

.select-region-label{
  width: 96px;
  height: 24px;
  border-radius: 4px;
  font-size: 14px;
  line-height: 24px;
  border: 1px solid #A7ADAF;
}
.select-region-label img{
  width: 12px;
  height: 12px;
  vertical-align: middle;
}
.top{
  width: 100%;
  height: 497px;
  font-size: 18px;
  font-weight: 400;
  padding-top: 68px;
  box-sizing: border-box;
  background: linear-gradient( 180deg, #F0FDFF 0%, #FFFFFF 100%);
}
.top .click-tip{
  font-weight: 600;
  font-size: 18px;
  color: #333333;
  line-height: 25px;
  margin-top: 57px;
}
.top .logo{
  width: 136px;
  height: 136px;
  background: rgba(54,180,198,0.06);
  border-radius: 10px;
  border: 1px dashed #36B4C6;
  margin: 40px auto 55px auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.top .logo img{
  width: 70px;
  height: 70px;
}
.top .logo div{
  font-size: 14px;
  color: #333333;
  margin-top: 10px;
}
.top .title{
  font-weight: 600;
}
.top div{
  line-height: 25px;
}
.desc .desc-name{
  font-size: 18px;
  color: #333333;
  line-height: 25px;
}
.desc .desc-text{
  font-size: 16px;
  color: #A7ADAF;
  line-height: 25px;
}

.app-container{
  display: flex;
}

</style>



// WEBPACK FOOTER //
// src/components/Index.vue